export const profileFormData = (state: RootState) => state.newProfile.formData;

export const profileFormError = (state: RootState) => state.newProfile.error;

export const profileFormCompleted = (state: RootState) => state.newProfile.completed;

export const profileFormSubmitting = (state: RootState) => state.newProfile.loading;